import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from "./context/AuthContext"
import { ThemeProvider } from './context/ThemeContext';
import { FitnessProfileProvider } from './context/FitnessProfileContext';
import "./styles/reset.css";
import "./styles/tokens.css";
import "./styles/themes.css";
import "./styles/base.css";
import "./styles/utilities.css";
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <FitnessProfileProvider>
          <ThemeProvider>
            <App />
          </ThemeProvider>
        </FitnessProfileProvider>
      </AuthProvider> 
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
